// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Gb72E","buttons":"Footer_buttons__2BpS1"};